import { render, staticRenderFns } from "./specs.vue?vue&type=template&id=1a5b5e45&scoped=true&"
import script from "./specs.vue?vue&type=script&lang=js&"
export * from "./specs.vue?vue&type=script&lang=js&"
import style0 from "./specs.vue?vue&type=style&index=0&id=1a5b5e45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b5e45",
  null
  
)

export default component.exports